<template>
  <!-- Start Navbar -->
  <nav class="navbar navbar-expand-lg fixed-top custom-nav sticky">
    <div class="container">
      <!-- LOGO -->
      <router-link class="navbar-brand brand-logo mr-4" to="/">
        <img
          src="../assets/images/logo_dark_1.png"
          width="220"
          class="img-fluid logo-light"
          alt=""
        />
        <img
          src="../assets/images/ma-logo.svg"
          width="200"
          class="img-fluid logo-dark"
          alt=""
        />
      </router-link>
      <div
        class="navbar-collapse collapse justify-content-end"
        id="navbarCollapse"
      >
        <ul class="navbar-nav navbar-center" id="mySidenav">
          <li class="nav-item">
            <router-link class="nav-link" to="/">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/about">About Us</router-link>
          </li>
          <!-- <li class="nav-item">
                        <router-link class="nav-link" to="/services">Services</router-link>
                    </li> -->
          <li class="nav-item">
            <router-link class="nav-link" to="/capabilities"
              >Capabilities</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/blog"
              >News/Publications</router-link
            >
          </li>
          <!-- <li class="nav-item">
                        <router-link class="nav-link" to="/portfolio2">Membership</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/blog">Newsroom</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/Events">Events</router-link>
                    </li> -->
          <li class="nav-item">
            <router-link class="nav-link" to="/contact">Contact Us</router-link>
          </li>
        </ul>
        <div class="menu-close-btn">
          <i class="mdi mdi-close-circle-outline"></i>
        </div>
      </div>
      <div class="header_btn">
        <button
          class="navbar-toggler ml-2 p-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="mdi mdi-menu"></i>
        </button>
      </div>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
export default {
  name: "template_header",
  methods: {},
};
</script>
